import { useParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/use-auth-store';
import { prepareSceneActor, loadSplatActor } from '../../actors/studio.actors';
import { Studio } from './studio';

export function SuperSplatViewport() {
    const { user } = useAuthStore();
    const { id } = useParams();
    const sceneId = id || 'mock-scene-01';
    const userId = user?.id || 'guest';

    return (
        <Studio 
            sceneId={sceneId}
            userId={userId}
            actors={{ prepareSceneActor, loadSplatActor }}
        />
    );
}
